<template>
    <div class="navigation-main">
        <div class="icon-l" :class="{['btn-primary'] : tabSelected === 'list'}" @click="changeTab('list')">
            <i class="fa-solid fa-list"></i>
            Liste
        </div>
        <div class="icon-l" :class="{['btn-primary'] : tabSelected === 'planner'}" @click="changeTab('planner')">
            <i class="fa-regular fa-calendar"></i>
            <template v-if="tabSelected === 'planner'">
                {{currentViewType == 'timeGridWeek' ? 'Semaine' : 'Mois'}}
                <i class="fa-solid fa-caret-down"></i>
            </template>
            <template v-else>
                Calendrier
            </template> 
        </div>
        <div class="icon-l" 
            :class="{['btn-primary'] : tabSelected === 'feed', disable: !isPageInstagramSelected}"
            @click="() => isPageInstagramSelected && changeTab('feed')"
         >
            <i class="fa-brands fa-instagram"></i>
            Feed
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            tabSelected: String,
            currentViewType: String,
        },

        methods: {
            changeTab(tabName) {
                if (this.tabSelected == tabName && tabName == 'planner') this.$emit('switchCurrentViewType')
                this.$emit('changeTab',tabName)
            },

           
        },
        computed: {
            isPageInstagramSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].filter(page => page.network == 'instagram').length;
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>